
import { mapActions, mapMutations, mapGetters } from 'vuex';
import CompareIcon from '@/components/svg/CompareIcon';
import CatalogIconEcom from '@/components/svg/mobile/CatalogIconEcom';
import CartIcon from '@/components/svg/CartIcon';
import ChatIcon from '@/components/svg/mobile/ChatIcon';
import FavoritesClearIcon from '@/components/svg/FavoritesClearIcon';
import header from '~/mixins/header';
export default {
    components: { ChatIcon, CartIcon, CatalogIconEcom, CompareIcon, FavoritesClearIcon },
    mixins: [header],
    computed: {
        ...mapGetters({
            mainPhoneNumber: 'global/mainPhoneNumber',
            isAuth: 'auth/isAuth',
            isVitrina: 'global/isVitrina',
            favoritesProductsLength: 'favorites/getProductsLength',
            compareProductsLength: 'compare/getCompareProductsLength',
            cartProductsLength: 'cart/getProductsLength',
            globalSettings: 'global/globalSettings'
        }),
        isCasaCart() {
            return this.globalSettings?.mainUiInterface?.cart_button_catalog_view_type === 'casadeltabaco';
        },
        isStepByStepCart() {
            return this.globalSettings?.mainUiInterface?.cart_button_catalog_view_type === 'step_by_step';
        }
    },
    methods: {
        ...mapActions('cart', ['openCart', 'closeCart']),
        ...mapMutations({
            setShowMenuMobile: 'setShowMenuMobile',
            initFavoritesProducts: 'favorites/initFavProducts'
        }),
        openCartMob() {
            if (this.isCasaCart || this.isStepByStepCart) {
                this.$router.push({ path: this.localePath('/cart') });
            } else {
                this.openCart();
                this.activeBarItem = 'cart';
            }
            // this.openCart();
            // this.activeBarItem = 'cart';
        },
        openCall() {
            this.closeCart();
            this.activeBarItem = 'call';
            window.open(`tel:${this.mainPhoneNumber?.replace(/\s/g, '')}`, '_self');
        },
        openCatalog() {
            this.setShowMenuMobile(true);
            this.activeBarItem = 'catalog';
            this.closeCart();
        },
        favoritesProducts() {
            if (process.client && localStorage?.getItem('favorites')) {
                this.initFavoritesProducts(JSON.parse(localStorage?.getItem('favorites')));
            } else {
                this.initFavoritesProducts([]);
            }
        }
    },
    watch: {
        activeBarItem(newValue) {
            if (newValue) {
                setTimeout(() => {
                    this.activeBarItem = null;
                }, 500);
            }
        }
    },
    data() {
        return {
            activeBarItem: null
        };
    },
    mounted() {
        this.favoritesProducts();
    }
};
